import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BreadcrumbService {
  cacheEtiquetas: Map<string, string> = new Map();
  private _cacheEtiquetasObs = new Subject();

  constructor() {}

  get cacheEtiquetasObservable() {
    return this._cacheEtiquetasObs.asObservable();
  }

  refrescarMarcasDeLugar() {
    this.traducirMarcasDeLugar(this.obtenerTraduccionMarcasDeLugar());
  }

  traducirMarcasDeLugar(etiquetas: {}) {
    this.almacenarEtiquetas(etiquetas);
    this._cacheEtiquetasObs.next(this.extraerEtiquetasDeCache());
  }

  obtenerTraduccionMarcasDeLugar(): string[] {
    return this.extraerEtiquetasDeCache();
  }

  limpiarCache() {
    this.cacheEtiquetas.clear();
  }

  private almacenarEtiquetas(etiquetas: {}) {
    Object.keys(etiquetas).forEach((clave) => {
      this.cacheEtiquetas.set(clave, etiquetas[clave]);
    });
  }

  private extraerEtiquetasDeCache(): string[] {
    let arrayResultado = [];
    this.cacheEtiquetas.forEach((valor, clave) => {
      arrayResultado[clave] = valor;
    });
    return arrayResultado;
  }
}
